import { useMemo, useState } from 'react';
import useUserSession from 'hooks/use-user-session';
import { useAtom } from 'jotai';
import { disconnectExtension } from 'services/safeExtensionService';
import { contactsAtom } from 'store/contacts';

import {
  bitcoinIcon,
  botanixIcon,
  // fractalIcon,
  merlinIcon,
  stacksIcon,
} from './images';

const networkOptions: {
  key: string;
  title: string;
  icon: string;
  link?: string;
  soon?: boolean;
  testnet?: boolean;
}[] = [
  {
    key: 'mainnet',
    title: 'Stacks',
    icon: stacksIcon,
    testnet: false,
  },
  {
    key: 'testnet',
    title: 'Stacks',
    icon: stacksIcon,
    testnet: true,
  },
  {
    key: 'bitcoin',
    title: 'Bitcoin',
    icon: bitcoinIcon,
    link: 'https://btc.asigna.io/',
  },
  {
    key: 'merlin',
    title: 'Merlin',
    icon: merlinIcon,
    link: 'https://sui.asigna.io/',
  },
  {
    key: 'botanix',
    title: 'Botanix',
    icon: botanixIcon,
    link: 'https://evm.asigna.io/',
  },
  // {
  //   key: 'fractal',
  //   title: 'Fractal',
  //   icon: fractalIcon,
  //   link: 'https://fractal.asigna.io/',
  // },
];

export const useConnectWalletButton = () => {
  const [, setContacts] = useAtom(contactsAtom);
  const [, , , signOut] = useUserSession();

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [connectModalOpen, setConnectModalOpen] = useState(false);

  const handleLogout = () => {
    setDropdownOpen(false);
    localStorage.clear();
    setContacts([]);
    signOut();
    disconnectExtension();
    window.location.href = '/';
  };

  return useMemo(
    () => ({
      isDropdownOpen,
      setDropdownOpen,
      connectModalOpen,
      setConnectModalOpen,
      handleLogout,
      networkOptions,
    }),
    [isDropdownOpen, connectModalOpen]
  );
};
